var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CustomerService"},[_c('a',{attrs:{"href":"https://work.weixin.qq.com/kfid/kfc9cf7803125222a78","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{attrs:{"src":"https://yike33.oss-cn-beijing.aliyuncs.com/0t0y1fnozp6qt4nq8td7.png","alt":""}}),_c('div',{staticClass:"text"},[_vm._v("联系客服")])])])
}]

export { render, staticRenderFns }